

























import Vue from 'vue'
import { getUserById, getUserStats } from '@/api/Users/users.api'
import { User, UserStats } from '@/api/Auth/auth.interface'
import { mapState } from 'vuex'
import { Iterable } from '@/utils/interfaces'
import { formatNumber } from '@/utils/functions'

export default Vue.extend({
  data: function() {
    return {
      profile: {} as User,
      stats: {} as UserStats,
    }
  },
  computed: {
    ...mapState({ user: 'profile' }),
    myData(): object {
      if (!Object.keys(this.profile).length) return {}
      const balance =
        formatNumber(this.user.balances.CUP) +
        ' CUP | ' +
        formatNumber(this.user.balances.USD) +
        ' USD'

      let response: Iterable = {
        balance,
      }
      if (this.$store.getters.profile.role === 'INTEGRATION') {
        return response
      } else if (this.user.services.length === 2) {
        response = {
          ...response,
          'topup.total': this.stats.topups_count,
          'remittance.total': this.stats.remittance_count,
        }
      } else if (this.user.services.includes('TOP-UP')) {
        response = {
          ...response,
          topup_credit: this.stats.topup_credit,
          'topup.total': this.stats.topups_count,
        }
      } else if (this.user.services.includes('REMITTANCE')) {
        response = {
          ...response,
          'remittance.total': this.stats.remittance_count,
          network_credit: 0,
        }
      }
      return response
    },
  },
  async mounted() {
    if (this.user.role !== 'INTEGRATION') {
      const stats = await getUserStats(this.user.uuid)
      this.stats = stats.data
    }
    const response = await getUserById(this.user.uuid)
    this.profile = response.data
  },
})
